// 控制页面布局的 比如控制侧边菜单栏isCollapse  是否显示标签页tagSwitch
import $api from "../../api/api";
const state = {
  // 整体---------------------
  mubanInfo: {}, //总模板信息
  fullscreenLoading: false, //是否全页面加载
  // head头部------------------------------
  menuList: [], //菜单列表
  chooseMenuId: undefined, //选中的菜单id
  // 中间-----------------------------------------------
  templateList: [], //中间编辑页面的list列表
  chooseComponentId: undefined, //中间编辑页面选中的组件id
  currentIndex: undefined, //中间编辑页面选中的组件下标，根据templateList跟chooseComponentId查出来的
  // 右边------------------------
  currentInfo: {}, //右侧栏的信息，包括标题，更多，图片以及wxSchoolPageItemList
  //!是否是因为更改了currentIndex，而触发改变currentInfo
  //这种情况下，是不会更新hasChanged为true的
  isChangeIndex: false,
  singleIndex: undefined, //右侧栏wxSchoolPageItemList选中的下标
  // 其他----------------------------
  hasChanged: false, //是否改变
  addDialogVisible: false, //新增弹窗
  addDialogSingle: false, //是否单选
  addRemark: undefined
};

const mutations = {
  GET_MUBAN: (state, val) => {
    state.mubanInfo = val;
  },
  GET_MENU: (state, val) => {
    state.menuList = val;
  },
  SET_CHOOSEID: (state, val) => {
    state.chooseMenuId = val;
  },
  SET_TEMPLATE: (state, val) => {
    state.templateList = val || [];
  },
  CHOOSE_COMPONENTID: (state, val) => {
    state.chooseComponentId = val;
  },
  HAS_CHANGED: (state, val) => {
    state.hasChanged = val;
  },
  CHANGED_INDEX: (state, val) => {
    state.isChangeIndex = val;
  },
  SET_CURRENTINFO: (state, val) => {
    state.currentInfo = val;
  },
  SET_CURRENTINDEX: (state, val) => {
    state.currentIndex = val;
  },
  SET_LOADING: (state, val) => {
    state.fullscreenLoading = val;
  },
  SET_ADDDIALOGVISIBLE: (state, val) => {
    state.addDialogVisible = val.addDialogVisible;
    state.addDialogSingle = val.single || false;
    state.singleIndex =
      val.singleIndex == undefined ? undefined : val.singleIndex;
    state.addRemark = val.remark || undefined;
  }
};

const actions = {
  //获取模板信息
  getMuban({ commit, dispatch }, val) {
    $api.wxSchoolPageTemplate.getWxSchoolPageTemplate({ id: val }).then(res => {
      commit("GET_MUBAN", res.data);
      dispatch("getMenu");
    });
  },
  //获取菜单
  getMenu({ dispatch, commit, state }) {
    $api.wxSchoolPageMenu
      .getWxSchoolPageMenuList({ schoolPageTemplateId: state.mubanInfo.id })
      .then(res => {
        commit("GET_MENU", res.data);
        if (!state.chooseMenuId && res.data.length != 0) {
          dispatch("setChooseId", res.data[0].id);
        }
        if (res.data.length == 0) {
          dispatch("setChooseId", undefined);
        }
      });
  },
  setChooseId({ commit, dispatch, state }, val) {
    commit("SET_CHOOSEID", val);
    commit("SET_LOADING", true);
    dispatch("reset");
    if (!val) {
      commit("SET_TEMPLATE", []);
      commit("HAS_CHANGED", false);
      commit("SET_LOADING", false);
    } else {
      $api.wxSchoolPage
        .getWxSchoolPageList({
          schoolPageMenuId: state.chooseMenuId,
          schoolPageTemplateId: state.mubanInfo.id
        })
        .then(res => {
          if (res.data) {
            commit("CHOOSE_COMPONENTID", res.data[0].typeId);
          }
          commit("SET_TEMPLATE", res.data);
          commit("HAS_CHANGED", false);
          commit("SET_LOADING", false);
        });
    }
  },
  addTemplate({ commit, state }, val) {
    let obj = JSON.parse(JSON.stringify(state.templateList));
    let e = 28;
    let typeId;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
      a = t.length,
      n = "";
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    typeId = new Date().getTime() + n;
    obj.push({
      component: val.title,
      type: val.type,
      componentDescribe: val.componentDescribe,
      typeId,
      wxSchoolPageItemList: []
    });
    if (obj.length == 1) {
      commit("CHOOSE_COMPONENTID", obj[0].typeId);
    }
    commit("SET_TEMPLATE", obj);
    commit("HAS_CHANGED", true);
  },
  updateTemplate({ commit, state }, val) {
    let obj = JSON.parse(JSON.stringify(state.templateList));
    obj[val.currentIndex] = val.currentInfo;
    commit("SET_TEMPLATE", obj);
    // 如果是点击中间模板导致的currentInfo的变化，则不认为是改变数据
    if (state.isChangeIndex) {
      commit("CHANGED_INDEX", false);
    } else {
      commit("HAS_CHANGED", true);
    }
  },
  reset({ commit }) {
    commit("SET_TEMPLATE", []);
    commit("CHOOSE_COMPONENTID", undefined);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/design.js